import o from"./shams.js";var f="undefined"!=typeof Symbol&&Symbol,t=o,y=function(){return"function"==typeof f&&("function"==typeof Symbol&&("symbol"==typeof f("foo")&&("symbol"==typeof Symbol("bar")&&t())))};export{y as default};
